module.exports = "<h5>{{ title }}</h5>\n<ul *ngIf=\"type === 'enum';else rampLegend\">\n  <li *ngFor=\"let elem of legend\">\n    <img src=\"{{ elem.icon }}\" >\n    <span>{{ elem.label }}</span>\n  </li>\n</ul>\n<ng-template #rampLegend>\n  <div class=\"rampWrapper\">\n    <span>{{ domain.min }}</span>\n    <ul>\n      <li *ngFor=\"let elem of legend\">\n        <img src=\"{{ elem.icon }}\">\n      </li>\n    </ul>\n    <span>{{ domain.max }}</span>\n  </div>\n</ng-template>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/map/legend/legend.component.html
// module id = ./src/app/map/legend/legend.component.html
// module chunks = main